var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isAuthenticated)?_c('b-nav-item',{attrs:{"href":"/signout"}},[_c('span',{attrs:{"slot":"button-content"},slot:"button-content"},[_c('font-awesome-icon',{attrs:{"icon":"sign-out-alt"}}),_c('span',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.$t('header.logout')))])],1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }